import setHiddenSlides from '../../../../src/js/set-hidden-slides';

class HeroSlider {
	constructor() {
		this.currentCountEl = document.querySelector('.block-hero-slider__current-count');
		this.slideContent = document.querySelector('.block-hero-slider__content');
		this.slideContentCards = document.querySelectorAll('.block-hero-slide-content');

		if (null === this.slideContent) {
			return;
		}

		this.setMinContentHeight();
		this.initSlider();

		window.addEventListener('resize', this.setMinContentHeight.bind(this));
	}

	setMinContentHeight() {
		let height = 0;

		if (window.matchMedia('(min-width: 768px)').matches) {
			this.slideContentCards.forEach((contentEl) => {
				if (contentEl.offsetHeight > height) {
					height = contentEl.offsetHeight;
				}
			});

			this.slideContent.style.minHeight = `${height}px`;
		} else {
			const currentSlide = this.slideContent.querySelector(
				`.block-hero-slide-content.active, .block-hero-slide-content:first-child`
			);
			this.slideContent.style.minHeight = 0;
			setTimeout(() => {
				this.slideContent.style.minHeight = `${currentSlide.offsetHeight}px`;
			}, 1);
		}
	}

	initSlider() {
		const setCurrentSlideCount = (swiper) => {
			const currentIndex = swiper.realIndex + 1;
			const newCount = (currentIndex + '').padStart(2, '0');
			if (null !== this.currentCountEl && null !== this.slideContent) {
				this.currentCountEl.innerHTML = newCount;
				this.slideContentCards.forEach((el) => el.classList.remove('active'));
				this.slideContent
					.querySelector(`.block-hero-slide-content:nth-child(${currentIndex}`)
					.classList.add('active');
			}
		};

		const handleSlideChange = (swiper) => {
			setCurrentSlideCount(swiper);

			if (!window.matchMedia('(min-width: 768px)').matches) {
				const currentSlide = this.slideContent.querySelector(
					`.block-hero-slide-content:nth-child(${swiper.realIndex + 1}`
				);

				this.slideContent.style.minHeight = `${currentSlide.offsetHeight}px`;
			}
		};

		// eslint-disable-next-line no-undef
		new Swiper('.block-hero-slider__slider', {
			slidesPerView: 1,
			loop: true,
			a11y: {
				slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
			},
			on: {
				init: setHiddenSlides,
				slideChange: handleSlideChange,
				slideChangeTransitionEnd: setHiddenSlides,
				breakpoint: setHiddenSlides,
			},
			navigation: {
				nextEl: '.block-hero-slider__next',
				prevEl: '.block-hero-slider__prev',
			},
		});
	}
}

new HeroSlider();
